import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';
import { API_URL } from '../../config/api';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Extract session_id from URL fragment
      const hash = location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        console.error('No session_id found');
        navigate('/');
        return;
      }

      const sessionId = sessionIdMatch[1];

      try {
        // Exchange session_id for app session
        const response = await axios.post(`${API_URL}/auth/session`, {
          session_id: sessionId
        }, { withCredentials: true });

        setUser(response.data);
        
        // Redirect to stories page (main app) after successful auth
        navigate('/stories', { state: { user: response.data } });
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/');
      }
    };

    processAuth();
  }, [location, navigate, setUser]);

  return (
    <div className="auth-callback">
      <div className="loading-spinner"></div>
      <p>Signing you in...</p>
    </div>
  );
};

export default AuthCallback;
